import React, { useEffect } from "react";
import { Button, Table } from "antd";
import { useModel } from "../../../models";
import { goPage } from "../../layout/pageDefinition";
import { useHistory } from "react-router";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";
import styles from '../../../assets/style/index.css'
import{ EditableRow, EditableCell} from "../../../components/editTable"
import StockStatisticService from "./StockStatisticService"
 import { message} from "antd";


export default function () {
    const [
        { stockList, searchParam, stockStatistics, stockPage, stockListSelectedRowKeys },
        { loadStockList,setStockList, setDetailVisible, setShiftVisible, setStockListSelectedRowKeys, exportStock }
    ] = useModel("stockStatistic");
    const [{ }, { setSearchParam }] = useModel("dinoutModel");
    const history = useHistory();
    const selectList =[
            { label: '否',value: 0  },
            { label: '是', value: 1 },
        ]
    

    const columns = [
        {
            title: '序号',
            width: 50,
            dataIndex: 'code',
            render: (_, __, index) => <span>{index + 1}</span>,
        },
        {
            title: '商品编号',
            width: 160,
            dataIndex: 'materialCode',
            align: 'left',
            render: (value, row, index) => {
                return (
                    <a onClick={() => {
                        setSearchParam({ materialCode: value })
                        goPage(history, "7-2")
                    }}>
                        {value}
                    </a>
                )
            }
        },
        {
            title: '商品名称',
            width: 180,
            ellipsis: true,
            dataIndex: 'materialName',
        },
        {
            title: '货位',
            width: 120,
            dataIndex: 'shelfCode',
        },
        {
            title: '库存数量',
            width: 80,
            dataIndex: 'inventoryNum',
        },
        {
            title: '库存总额',
            width: 80,
            dataIndex: 'inventoryTotal',
        },
        {
            title: '进货价',
            width: 80,
            dataIndex: 'purchasePrice',
        },
        {
            title: '销售价',
            width: 80,
            dataIndex: 'salesPrice',
        },
        {
            title: '销售成本',
            width: 80,
            dataIndex: 'saleCost',
        },
        {
            title: '商品类型',
            width: 120,
            dataIndex: 'categoryName',
        },
        {
            title: '图号',
            width: 120,
            dataIndex: 'replaceNum',
        },
        /*{
            title: '单位',
            width: 80,
            dataIndex: 'materialUnit',
        },*/

        {
            title: '发动机型号',
            width: 180,
            dataIndex: 'engineTypeName',
        },
        {
            title: '二级销价',
            width: 80,
            dataIndex: 'subSalesPrice',
        },
        {
            title: '库存上限',
            width: 80,
            dataIndex: 'inventoryCap',
        },
        {
            title: '库存下限',
            width: 80,
            dataIndex: 'inventoryFloor',
        },
        {
            title: '仓库',
            width: 160,
            ellipsis: true,
            dataIndex: 'warehouseName',
        },
        {
            title: '规格',
            width: 120,
            dataIndex: 'specification',
        },
        {
            title: '占用库存',
            width: 80,
            dataIndex: 'holdNum',
        },
        {
            title: '可用库存',
            width: 80,
            dataIndex: 'availableNum',
        },
        {
            title: '未销售天数',
            width: 90,
            dataIndex: 'backlogDay',
           
           
        },
        {
            title: '是否积压',
            editable:true,
            editType:"select", 
            selectList:[
                { label: '否',value: 0  },
                { label: '是', value: 1 },
            ],
            width: 80,
            dataIndex: 'isBacklog',
            render:(text)=>{if(text==0){return text ='否'}else{return text = '是'}}
        }

        /*{
                title: '采购成本',
                width: 80,
                dataIndex: 'procurementCost',
            },*/
        /*{
            title: '产地',
            width: 120,
            dataIndex: 'materialManufacturer',
        },
        {
            title: '品牌',
            width: 120,
            dataIndex: 'materialBrandName',
        },
        {
            title: '供应商',
            width: 160,
            ellipsis: true,
            dataIndex: 'supplerName',
        },*/

        /*{
            title: '公司名称',
            width: 160,
            ellipsis: true,
            dataIndex: 'orgName',
        },*/

    ];

    useEffect(() => {
        const { pageNum, pageSize } = stockPage
        const data = { ...searchParam, pageNum, pageSize };
        loadStockList({ showMsg: true, data });
    }, []);

    const onDetail = () => {
        setDetailVisible(true);
    }
    /*const onPssDetail = () => {
        setPssVisible(true);
    }*/

    const onExport = () => {
        exportStock({ showMsg: true, data: { ...searchParam } });
    }
    const onShift = () => {
        setShiftVisible(true);
    }

    const TableHeader = () => {
        return (
            <div style={{ margin: "0 0 8px", display: "flex" }}>
                <div style={{ width: "460px", paddingTop: "6px" }}>
                    {/* <YhAuth resCode={ResourceAuthEnum.P_AD}> */}
                    <Button
                        type="primary"
                        onClick={onDetail}
                        disabled={stockListSelectedRowKeys.length === 0}
                        hidden={true}
                    >
                        查看
                    </Button>
                    {/* </YhAuth> */}
                    {/*<Button className="margin-left-8" onClick={onPssDetail}>进销存明细</Button>*/}
                    <YhAuth resCode={ResourceAuthEnum.ST_INVENT_TRANS}>
                        <Button
                            className="margin-left-8"
                            onClick={onShift}
                            disabled={stockListSelectedRowKeys.length === 0}
                        >
                            移库
                    </Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.ST_INVENT_EX}>
                        <Button className="margin-left-8" onClick={onExport}>导出</Button>
                    </YhAuth>
                </div>
                <div className="detail-list-statistic color-primary" style={{ textAlign: "right" }}>
                    <span className="margin-left-8">
                        库存总数量：{stockStatistics ? stockStatistics.inventoryNumTotal : 0}
                    </span>
                    <span className="margin-left-16">
                        库存种类：{stockStatistics ? stockStatistics.inventoryCount : 0}
                    </span>
                    {/*<span className="margin-left-16">
                        采购成本：{stockStatistics ? stockStatistics.procurementCostTotal : 0.00}
                    </span>*/}
                    <span className="margin-left-16">
                        库存总额：{stockStatistics ? stockStatistics.inventoryPriceTotal : 0.00}
                    </span>
                </div>
            </div>
        )
    }

    const newSelectColumns = columns.map((col,index) => {
        return {
            ...col,
            onCell: (record) => ({
                record,
                rules: col.rules,
                editType: col.editType,
                editable: col?.editable,
                dataIndex: col.dataIndex,
                handleSave: handleSave,
                selectList:col?.selectList
                
            }),
        }
    })

    const handleSave =(row)=>{
        let data = [...stockList]
        const index = data.findIndex((item) => row.key === item.key);
        const item = data[index];
        data.splice(index, 1, { ...item, ...row });
        setStockList(data)
        console.log(row.partId)
        StockStatisticService.isoverstock(row.partId,row.isBacklog)
        if(row.isBacklog !==item.isBacklog){
              message.success('修改成功!', 10)
        }
        if(row.isBacklog ===item.isBacklog){
            return true
        }
        

    }

    return (
        <>
            <TableHeader />
            <Table
                columns={newSelectColumns}
                dataSource={stockList}
                bordered
                rowClassName={(record)=>{
                    if(record.backlogDay >=150){
                        return 'checkstyle'; 
                   }
                }}
                pagination={{
                    hideOnSinglePage: false,
                    showSizeChanger: true,
                    pageSizeOptions: [15, 50, 100, 200, 500],
                    defaultCurrent: 1,
                    defaultPageSize: 15,
                    onChange: (page, pageSize) => {
                        const params = { ...searchParam };
                        params.pageNum = page;
                        params.pageSize = pageSize;
                        loadStockList({ showMsg: false, data: params });
                    },
                    total: stockPage.total,
                    current: stockPage.pageNum,
                }}
                onRow={record => {
                    return {
                        onClick: event => {
                            if (stockListSelectedRowKeys
                                && stockListSelectedRowKeys[0]
                                && stockListSelectedRowKeys[0] === record.key) {
                                setStockListSelectedRowKeys([]);
                            } else {
                                setStockListSelectedRowKeys([record.key]);
                            }
                        },
                    };
                }}
                rowSelection={{
                    type: "radio",
                    onChange: (selectedRowKeys) => {
                        setStockListSelectedRowKeys(selectedRowKeys)
                    },
                    selectedRowKeys: stockListSelectedRowKeys
                }}
                scroll={{ x: 'max-content', y: 560 }}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                
            />
        </>
    );
}
